import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';
import { loadData } from '../../../../core/components/core/Util/List/CustomList/loadData';

function List() {
    const profileFilter = chooseProfileFilter();

    const pathFrontEnd = '/contracts/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',
        endpointGetAllSuppliers: config.endpoints.backend + 'people/getSuppliers',
        endpointGetAllContractTypes: config.endpoints.backend + 'contracttypes/getall',
        endpointDelete: `${config.endpoints.backend}contracts/delete`,
        endpoint: config.endpoints.backend + 'contracts/getall'
    }

    const pathsForm = {
        endpointSave: config.endpoints.backend + 'contracts/save',
        endpointGetById: config.endpoints.backend + 'contracts/getById',
        endpointGetByContractNumber: config.endpoints.backend + 'contracts/getByContractNumber',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',
        endpointGetAllProcesses: config.endpoints.backend + 'processes/getall',
        endpointGetAllSuppliers: config.endpoints.backend + 'suppliers/getall',
        endpointGetAllContractTypes: config.endpoints.backend + 'contracttypes/getall',
        endpointGetAllContractStatuses: config.endpoints.backend + 'contractstatuses/getall'
    }

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            {
                name: 'pdc_project_id',
                type: 'select',
                label: 'Projeto',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllProjects,
                    label: 'project_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 3
            },
            {
                name: 'pdc_people_id',
                type: 'select',
                label: 'Fornecedor',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllSuppliers,
                    label: 'corporate_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 3
            },
            {
                name: 'pdc_contract_type_id',
                type: 'select',
                label: 'Tipo de Contrato',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllContractTypes,
                    label: 'name',
                    value: 'id'
                },
                validations: {
                    required: false
                },
                columnSize: 3,
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 1
            },
        ]
    }

    let list = {
        labelTitle: 'Lista de Contratos',
        labelTitleButtonAdd: 'Incluir novo Contrato',
        fieldsShowOnDelete: ['contract_number'],
        canDownload: true,
        fieldToDownload: 'file',
        formFilters: filters,
        filter: {
            ...profileFilter
        },
        columns: [
            {
                name: 'contract_number',
                label: 'Número do Contrato',
                width: '15%'
            },
            {
                name: 'project',
                label: 'Projeto',
                width: '10%'
            },
            {
                name: 'process_number',
                label: 'Número do Processo',
                width: '15%'
            },
            {
                name: 'supplier_name',
                label: 'Fornecedor',
                width: '20%'
            },
            {
                name: 'contract_type',
                label: 'Tipo de Contrato',
                width: '12%'
            },
            {
                name: 'months_amount',
                label: 'Meses',
                width: '8%'
            },
            {
                name: 'monthly_value',
                label: 'Valor Mensal',
                width: '12%'
            },
            {
                name: 'days_amount',
                label: 'Dias',
                width: '8%'
            },
            {
                name: 'daily_value',
                label: 'Valor Diário',
                width: '12%'
            },
            {
                name: 'total_value',
                label: 'Valor Total',
                width: '15%'
            },
            {
                name: 'effective_date',
                label: 'Data de Vigência',
                width: '12%'
            },
            {
                name: 'situation',
                label: 'Situação',
                width: '12%'
            },
            {
                name: 'object',
                label: 'Objeto'
            }
        ]
    };

    list = { ...list, ...paths };

    let form = {
        fields: [
            {
                name: 'pdc_project_id',
                type: 'select',
                label: 'Projeto',
                options: [],
                optionsEndpoint: {
                    endpoint: pathsForm.endpointGetAllProjects,
                    label: 'project_name',
                    value: 'id'
                },
                validations: {
                    required: false
                },
                columnSize: 6
            },
            {
                name: 'pdc_process_id',
                type: 'select',
                label: 'Processo',
                options: [],
                optionsEndpoint: {
                    endpoint: pathsForm.endpointGetAllProcesses,
                    label: 'process_number',
                    value: 'id'
                },
                validations: {
                    required: true
                },
                columnSize: 6,
            },
            {
                name: 'pdc_people_id',
                type: 'select',
                label: 'Fornecedor',
                options: [],
                optionsEndpoint: {
                    endpoint: pathsForm.endpointGetAllSuppliers,
                    label: 'corporate_name',
                    value: 'id'
                },
                validations: {
                    required: true
                },
                columnSize: 12
            },
            {
                name: 'pdc_contract_type_id',
                type: 'select',
                label: 'Tipo de Contrato',
                options: [],
                optionsEndpoint: {
                    endpoint: pathsForm.endpointGetAllContractTypes,
                    label: 'name',
                    value: 'id'
                },
                validations: {
                    required: true
                },
                columnSize: 6,
            },
            {
                name: 'pdc_contract_status_id',
                type: 'select',
                label: 'Situação',
                options: [],
                optionsEndpoint: {
                    endpoint: pathsForm.endpointGetAllContractStatuses,
                    label: 'name',
                    value: 'id'
                },
                validations: {
                    required: true
                },
                columnSize: 6,
            },
            {
                name: 'contract_number',
                type: 'text',
                mask: '999999/9999',
                label: 'Número do Contrato',
                validations: {
                    required: true,
                },
                columnSize: 12
            },
            {
                name: 'months_amount',
                type: 'integer',
                label: 'Quantidade de Meses',
                validations: {
                    required: true
                },
                columnSize: 6
            },
            {
                name: 'monthly_value',
                type: 'decimal',
                label: 'Valor Mensal',
                validations: {
                    required: false
                },
                columnSize: 6,
            },
            {
                name: 'signature_date',
                type: 'date',
                label: 'Data de Assinatura',
                validations: {
                    required: true
                },
                columnSize: 4
            },
            {
                name: 'effective_date',
                type: 'date',
                label: 'Data de Vigência',
                validations: {
                    required: true
                },
                columnSize: 4
            },
            {
                name: 'payment_condition',
                type: 'text',
                label: 'Condição de Pagamento',
                validations: {
                    required: true
                },
                columnSize: 4
            },
            {
                name: 'file',
                type: 'fileS3',
                label: 'Arquivo',
                validations: {
                    required: true
                },
                columnSize: 6
            },
            {
                name: 'observation',
                type: 'textarea',
                label: 'Observação',
                validations: {
                    required: false
                },
                columnSize: 12
            }
        ],
        ...pathsForm,
        labelTitleModal: 'Visualizar Contrato'
    }

    list.formToModal = form;

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
